import * as PropTypes from "prop-types";
import {connect} from 'react-redux'
import {ActionsRow, FixedDropDownButton} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import './DummyActionsRow.scss';

/**
 * Neviditelná komponenta, sloužící pro zarovnání sloupců v záhlaví a v obsahu tabulky do doby, než přijdu na lepší řešení.
 */
class DummyActionsRow extends Component {

    static propTypes = {
        children: PropTypes.element,
    };

    render() {
        const {children} = this.props;
        return <ActionsRow actions={<FixedDropDownButton><span/></FixedDropDownButton>} className="dummy-actions-row">
            {children}
        </ActionsRow>
    }
}

export default connect()(DummyActionsRow);
